import angular from 'angular';
import _ from 'lodash-es';

export default class CustomController {
	/* @ngInject */
	/**
	 * @param {any} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {any} KformComponents
	 */
	constructor($scope, $timeout, KformComponents) {
		// Because of the weirdnesses of prototype inheritence, components can't update themselves, only their properties.
		$scope.customComponent = angular.copy($scope.component);
		$scope.$watch('customComponent', (/** @type {any} */ newComponent) => {
			if (newComponent) {
				// Don't allow a type of a real type.
				newComponent.type = (Object.prototype.hasOwnProperty.call(KformComponents.components, newComponent.type)
					? 'custom' : newComponent.type);

				// Ensure some key settings are set.
				newComponent.key = newComponent.key || newComponent.type;

				newComponent.protected = (Object.prototype.hasOwnProperty.call(newComponent, 'protected')
					? newComponent.protected : false);

				newComponent.persistent = (Object.prototype.hasOwnProperty.call(newComponent, 'persistent')
					? newComponent.persistent : true);

				$scope.$applyAsync(() => {
					$scope.$emit('updateKey', newComponent);
					_.assign($scope.component, newComponent);
				});
			}
		});
	}
}
